"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _CustomIconOrImage = _interopRequireDefault(require("../../shared/CustomIconOrImage"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CollapsibleHeaderContentWrapper = _styledComponents.default.div`
  display: flex;
  gap: 8px;
`;
const CollapsibleBodyContentWrapper = _styledComponents.default.div`
  display: flex;
  gap: 10px;
  padding: ${props => `0px ${props.padding}`};
`;
const Wrapper = _styledComponents.default.div`
  & .injected-svg {
    ${props => !props.shouldOverrideBlack && (0, _styledComponents.css)`
        stroke: #0d0d0d;
      `}
  }
`;
const CollapsibleCharacteristic = _ref => {
  let {
    icon,
    state,
    text,
    description,
    src
  } = _ref;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const collapsibleFeatureDescriptionSpacing = (0, _useLocalTheme.default)(`recommendation.collapsibleFeatureDescriptionSpacing`, {});
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    shouldOverrideBlack: state === 'error'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, {
    onToggle: status => {
      setIsOpen(status);
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, /*#__PURE__*/_react.default.createElement(CollapsibleHeaderContentWrapper, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    src: src,
    name: icon,
    state: 'error'
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, text))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, isOpen && /*#__PURE__*/_react.default.createElement(CollapsibleBodyContentWrapper, {
    padding: `${collapsibleFeatureDescriptionSpacing[breakpoints.current] + 8}px`
  }, /*#__PURE__*/_react.default.createElement("ul", null, description.map(el => /*#__PURE__*/_react.default.createElement("li", {
    key: el
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, el))))))));
};
var _default = CollapsibleCharacteristic;
exports.default = _default;